import { useEffect, useState } from 'react';
import { DEFAULT_ROWS_PER_PAGE } from '../constants/supplierLedgerUiConstants';

const useClientPagination = (rows, initialRowsPerPage = DEFAULT_ROWS_PER_PAGE) => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
  const totalCount = rows.length;
  const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage) || 1);
  const safePage = Math.min(page, totalPages);
  const startIndex = (safePage - 1) * rowsPerPage;
  const paginatedRows = rows.slice(startIndex, startIndex + rowsPerPage);

  useEffect(() => {
    if (page !== safePage) {
      setPage(safePage);
    }
  }, [page, safePage]);

  return {
    page: safePage,
    rowsPerPage,
    totalCount,
    totalPages,
    paginatedRows,
    handlePageChange: (_, value) => setPage(value),
    handleRowsPerPageChange: (event) => {
      setRowsPerPage(Number(event.target.value));
      setPage(1);
    },
  };
};

export default useClientPagination;
